export const types = {
    1 : "Previous Pregnancy (History)",
    2 : "Current Pregnancy (Pregnant)",
    3 : "Pre-Pregnacy (Trying to concieve)"
}

export const pregnancyType = [
    { value: 1, label: 'Previous Pregnancy (History)', category: 'documentDetails.documentType' },
    { value: 2, label: 'Current Pregnancy (Pregnant)', category: 'pregnancyStage' },
    { value: 3, label: 'Pre-Pregnacy (Trying to concieve)', category: 'documentDetails.documentType' }
]

export const ph = [
    {
        label: "Prescription",
        value: 0
    },
    {
        label: "Blood Reports",
        value: 1
    }, 
    {
        label: "Ultrasound Reports",
        value: 2
    }, 
    {
        label: "X-Ray Reports",
        value: 3
    },
    {
        label: "Discharge Summary (Normal Pregnancy /Abortion/Miscarriage)",
        value: 4
    },
    {
        label: "Any Other Report",
        value: 5
    }
]

export const cp = [
    {
        label: "0-6 Weeks",
        value: 0
    },
    {
        label: "7-15 Weeks",
        value: 1
    },
    {
        label: "16-27 Weeks",
        value: 2
    },
    {
        label: "28-32",
        value: 3
    },
    {
        label: "33-Term",
        value: 4
    }
]

export const documentsType = {
    0 : [{
            label: "Prescription",
            value: 0
        },
        {
            label: "Urine Dip test",
            value: 1
        },
        {
            label: "Blood Report",
            value: 2
        },
        {
            label: "Ultrasound",
            value: 3
        },
        {
            label: "X- Ray",
            value: 4
        },
        {
            label: "Any other Report",
            value: 5
        }
    ],
    1 : [{
            label: "Prescription",
            value: 0
        },
        {
            label: "1st Screening report (HCG, PAPPCA, Quadruple, triple, double marker test)",
            value: 1
        },
        {
            label: "Blood Report",
            value: 2
        },
        {
            label: "Ultrasound",
            value: 3
        }, 
        {
            label: "Any other Report",
            value: 4
        }
    ], 
    2: [{
            label: "Prescription",
            value: 0
        },
        {
            label: "2nd Screening reports (if any) (Chronic V.S, Chordocenter, Fetal DNA, Fetal echography etc.)",
            value: 1
        },
        {
            label: "Blood Report",
            value: 2
        },
        {
            label: "Ultrasound",
            value: 3
        },
        {
            label: "X ray Report",
            value: 4
        }, 
        {
            label: "Any other Report",
            value: 5
        }
    ],
    3:  [{
            label: "Prescription",
            value: 0
        },
        {
            label: "Discharge summary",
            value: 1
        },
        {
            label: "Procedure/Surgery if any",
            value: 2
        },
        {
            label: "Blood Report",
            value: 3
        },
        {
            label: "Ultrasound",
            value: 4
        }, 
        {
            label: "X-ray Report",
            value: 5
        },
        {
            label: "Any other Report",
            value: 6
        }
    ], 
    4:  [{
            label: "Prescription",
            value: 0
        },
        {
            label: "Discharge summary",
            value: 1
        },
        {
            label: "Procedure/Surgery if any",
            value: 2
        },
        {
            label: "Blood Report",
            value: 3
        },
        {
            label: "Ultrasound",
            value: 4
        }, 
        {
            label: "X-ray Report",
            value: 5
        },
        {
            label: "Any other Report",
            value: 6
        }
    ], 
}

export const concieveMethod = [
    {
        label: "Normal Pregnancy",
        value: 0    
    },
    {
        label: "IVF/IUI",
        value: 1
    }
];

export const subDocument = [
    {
        label: "Follicle Reports",
        value: 0
    },
    {
        label: "Semen analysis",
        value: 1
    }, 
    {
        label: "Laparoscopy/Hysteroscopy",
        value: 2
    },
    {
        label: "IUI",
        value: 3
    }, 
    {
        label: "IVF",
        value: 4
    },
    {
        label: "Hormone therapy",
        value: 5
    },
    {
        label: "Other",
        value: 6
    }
];

export const childSubdocument = [
    {
        label: "Health illness",
        value: 0
    },
    {
        label: "Development issue",
        value: 1
    },
    {
        label: "New Born Record",
        value: 2
    },
    {
        label: "Vaccination",
        value: 3
    },
    {
        label: "Other",
        value: 4
    }
];

export const childDocument = [
    {
        label: "Prescriptions",
        value: 0
    },
    {
        label: "Blood Reports",
        value: 1
    },
    {
        label: "Ultrasound Reports",
        value: 2
    },
    {
        label: "X-Ray Reports",
        value: 3
    },
    {
        label: "Procedure/Surgeries/ Discharge Summary",
        value: 4
    },
    {
        label: "Child Assessment/Therapy Charts",
        value: 5
    },
    {
        label: "Any Other Report",
        value: 6
    },
];

export const medicalDocument = [
    {
        label: "Prescriptions",
        value: 0,
    },
    {
        label: "Blood Reports",
        value: 1
    },
    {
        label: "Ultrasound Reports",
        value: 2
    },
    {
        label: "X-Ray Reports",
        value: 3
    }, 
    {
        label: "Procedure/Surgeries/ Discharge Summary",
        value: 4
    },
    {
        label: "Any Other Report",
        value: 5
    }
]

export const medicalSubDocument = [
    {
        label: "Health illness",
        value: 0
    },
    {
        label: "Other",
        value: 1
    }
]

export const recordType = [
    {
        label: "Pregnancy Record",
        value: 0
    },
    {
        label: "Child Record",
        value: 1
    },
    {
        label: "General Medical Record",
        value: 2
    },
    {
        label: "Pregnancy Vitals",
        value: 3
    }
]

export const vitalsOptions = [
    { label: "Thyroid", value: 1 },
    { label: "Blood Sugar", value: 2 },
    { label: "Blood Pressure", value: 3}
]

export const childTableHeader = [
    // { label: "S.No", value: ""},
    { label: "Date of Appointment", value: ""},
    { label: "Hospital/Clinic", value: "hospitalName"},
    { label: "Doctor Name", value: "doctorName"},
    { label: "Sub Type of Document", value: "subDocumentType"},
    { label: "Title of Document(s)", value: "title"},
]

export const medicalTableHeader = [
    // { label: "S.No", value: ""},
    { label: "Date of Appointment", value: "appointment"},
    { label: "Hospital/Clinic", value: "hospitalName"},
    { label: "Doctor Name", value: "doctorName"},
    { label: "Sub Type of Document", value: "subDocumentType"},
    { label: "Title of Document(s)", value: "title"},
    { label: "File Uploaded", value: ""},
]

export const thyroidTableHeader = [
    // { label: "S.No", value: ""},
    { label: "Date & Time of Test", value: "testDate"},
    { label: "Lab Name", value: "lab"},
    { label: "T3 Levels(ng/dl)", value: "t3"},
    { label: "T4 Levels(ng/dl)", value: "t4"},
    { label: "FT3 Levels(ng/dl)", value: "ft3"},
    { label: "FT4 Levels(ng/dl)", value: "ft4"},
    { label: "TSH Levels(ng/dl)", value: "tsh"}
]

export const bloodSugarTableHeader = [
    // { label: "S.No", value: ""},
    { label: "Date & Time of Test", value: "testDate"},
    { label: "Lab Name", value: "lab"},
    { label: "HbA1c(in %)", value: "Hba1c"},
    { label: "Pre Meal Blood Sugar(mg/dl)", value: "preMealBloodSugar"},
    { label: "Post Meal Blood Sugar(mg/dl)", value: "postMealBloodSugar"},
    { label: "UrineSugar(mg/dl)", value: "urineSugarF"},
    { label: "UrineSugar(pp)(mg/dl)", value: "urineSugarPP"}
]

export const bloodPressureTableHeader = [
    // { label: "S.No", value: ""},
    { label: "Date & Time of Test", value: "testDate"},
    { label: "HbA1c(in %)", value: ""},
    { label: "Pre Meal Blood Sugar(mg/dl)", value: ""},
    { label: "Post Meal Blood Sugar(mg/dl)", value: ""},
    { label: "UrineSugar(mg/dl)", value: ""},
    { label: "UrineSugar(pp)(mg/dl)", value: ""}
]

export const previousPregnancyHeader = [
    // { label: "S.No", value: "" },
    { label: "Date of Appointment", value: "appointment" },
    { label: "Hospital/Clinic", value: "hospitalName" },
    { label: "Doctor Name", value: "gynecologistName" },
    { label: "Concieving Method", value: "" },
    { label: "Title of Document(s)", value: "title" },
    // { label: "File Uploaded", value: "" }
]
export const currentPregnancyHeader = [
    // { label: "S.No" , value: "" },
    { label: "Date of Appointment" , value: "appointment" },
    { label: "Hospital/Clinic" , value: "hospitalName" },
    { label: "Doctor Name" , value: "gynecologistName" },
    { label: "Types of Document(s)" , value: "" },
    { label: "Title of Document(s)" , value: "title" }
]

export const prePregnancyHeader = [
    // { label: "S.No", value: "" },
    { label: "Date of Appointment", value: "appointment" },
    { label: "Hospital/Clinic", value: "hospitalName" },
    { label: "Doctor Name", value: "gynecologistName" },
    { label: "Sub Type of Document", value: "" },
    { label: "Title of Document(s)", value: "" }
]




// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/configData.js